const defaultFilters = {
  programYears: [],
  gender: null,
};
export default defaultFilters;
